export default {
   // rootGetter so getterji v main index.js 
    requests(state, _, _2, rootGetters) {
                                // userId je getter iz index.js
        const coachId = rootGetters.userId
        console.log(state.requests)
            // funkcija .filter nam omogiči da gremo čez vse requeste
                                    // in najde req.coachId ki je enak coachId
                                    // samo tej requesti so nato tukaj returnani
        return state.requests.filter(req => req.coachId === coachId);
    },
    // če je vsaj 1 request
    hasRequests(_, getters) {
        return getters.requests && getters.requests.length > 0
    }
};
